import { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "@/components/layout/Sidebar";
import CopilotPanel from "@/components/CopilotPanel";
import PrivacyDisclaimer from "@/components/PrivacyDisclaimer";
import ProjectChip from "@/components/ProjectChip";

export default function Layout() {
  const [copilotOpen, setCopilotOpen] = useState(false);
  return (
    <div className="flex min-h-screen theme-bg theme-ink">
      <PrivacyDisclaimer />
      <Sidebar onOpenCopilot={() => setCopilotOpen(true)} />
      <main className="flex-1 min-w-0">
        <ProjectChip />
        <Outlet />
      </main>
      <CopilotPanel open={copilotOpen} onClose={() => setCopilotOpen(false)} />
    </div>
  );
}
